<template>
  <v-badge v-if="status" bottom bordered :color="getStatusColor()" dot offset-x="12" offset-y="12">
    <v-avatar @click="viewMember()" :size="size ? size : '35'" class="initials-avatar">
      <ImageDisplay v-if="image" :src="image" />

      <span v-else-if="name" class="white--text font-weight-bold">{{ getInitials(name) }}</span>

      <img v-else :src="assets() + '/default-profile-avatar.png'" />
    </v-avatar>
  </v-badge>

  <v-avatar v-else @click="viewMember()" :size="size ? size : '35'" class="initials-avatar">
    <ImageDisplay v-if="image" :src="image" />

    <span v-else-if="name" class="white--text font-weight-bold">{{ getInitials(name) }}</span>

    <img v-else :src="assets() + '/default-profile-avatar.png'" />
  </v-avatar>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  props: ["image", "status", "size", "id", "minor", "name"],
  methods: {
    viewMember() {
      if (this.id)
        this.navigateTo({ name: "viewmember", params: { memberid: this.id } });
    },
    getStatusColor() {
      return this.getTransactionStatusColor(this.status);
    },
    getInitials(name) {
      if (!name) return "";
      const parts = name.trim().split(' ');
      // Takes first letter of first name and first letter of second name
      const initials = parts.length > 1
        ? parts[0][0] + parts[1][0]
        : parts[0][0];
      return initials.toUpperCase();
    }
  }
};
</script>
<style scoped>
.initials-avatar {
  background-color: #bdbdbd;
  /* A neutral grey */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>